import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { Person } from "@common/ADAPT.Common.Model/person/person";
import { CommonDataService } from "@common/lib/data/common-data.service";
import { AdaptError } from "@common/lib/error-handler/adapt-error";
import { ErrorHandlingUtilities } from "@common/lib/utilities/error-handling-utilities";
import { PersonImageComponent } from "@common/user/person-image/person-image.component";
import { UserService } from "@common/user/user.service";
import { PersonProfileService } from "@org-common/lib/person-profile/person-profile.service";
import { WorkflowStepComponent } from "@org-common/lib/workflow/workflow-component-registry";
import { WorkflowStepComponentAdapter } from "@org-common/lib/workflow/workflow-step-component-adapter";
import { throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";

export const SetUpProfileComponentSelectorName = "adapt-set-up-profile";

@WorkflowStepComponent(SetUpProfileComponentSelectorName)
@Component({
    selector: "adapt-set-up-profile",
    templateUrl: "./set-up-profile.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class SetUpProfileComponent extends WorkflowStepComponentAdapter implements OnInit {
    public person: Person | undefined;
    public defaultImageSrc = PersonImageComponent.DefaultProfileImageUrl;

    constructor(
        private userService: UserService,
        private personProfileService: PersonProfileService,
        private commonDataService: CommonDataService,
    ) {
        super();
    }

    public async ngOnInit() {
        this.person = this.userService.currentPerson!;
    }

    public workflowStepNext() {
        // this is to save the first and last name.
        return this.commonDataService.saveEntities(this.person);
    }

    public updateProfileImageIdentifier(person: Person, imageIdentifier: string) {
        this.personProfileService.updateImageIdentifier(person, imageIdentifier).pipe(
            tap(() => this.workflowStepErrorMessage.next(undefined)),
            catchError((err) => {
                const errorMessage = ErrorHandlingUtilities.getHttpResponseMessage(err);
                this.workflowStepErrorMessage.next(errorMessage);
                return throwError(() => new AdaptError(errorMessage));
            }),
        ).subscribe();
    }
}
